import { useMutation, useQueryClient } from '@tanstack/react-query'
import ConfirmationModal from 'components/ConfirmationModal'
import { QUERY_KEYS } from 'constants/keys'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

type DeleteProps = {
  opened: boolean
  closeModal: () => void
  activityTask: ActivityTaskApiResponse
}

export default function Delete({
  opened,
  closeModal,
  activityTask,
}: DeleteProps) {
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  const { openErrorToast, openSuccessToast } = useGlobalState()

  const removeActivityTask = useMutation({
    mutationFn: async (activityTask: ActivityTask) => {
      await ApiService.ActivityTasks.remove(
        activityTask.id?.toString() as string,
      )
    },
    onSuccess: (_data, activityTask: ActivityTask) => {
      queryClient.setQueryData<ActivityTask[]>(
        QUERY_KEYS.ACTIVITY_TASKS.LIST,
        (oldActivityTask) => {
          if (!oldActivityTask?.length) return

          return oldActivityTask.filter(
            (oldActivityTask) => oldActivityTask.id !== activityTask.id,
          )
        },
      )

      queryClient.removeQueries(
        QUERY_KEYS.ACTIVITY_TASKS.EDIT(activityTask.id?.toString() as string),
      )

      openSuccessToast({
        message: `A tarefa ${activityTask.name} foi removido com sucesso!`,
      })

      navigate(ROUTES.ACTIVITY_TASKS.LIST)
    },
    onError: (removeError) => {
      closeModal()

      openErrorToast({
        message: (removeError as ApiError).message,
      })
    },
  })

  if (!opened) {
    return <></>
  }

  return (
    <ConfirmationModal
      opened
      title="Confirmar remoção"
      onClose={closeModal}
      onCancel={closeModal}
      onConfim={() => removeActivityTask.mutate(activityTask)}
      confirmColor="error"
    >
      Deseja realmente remover a tarefa{' '}
      <strong>{`${activityTask?.name}?`}</strong>
    </ConfirmationModal>
  )
}
